import React, { memo } from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Todo tu trabajo repartido en mil lugares (cuadernos, WhatsApp, notas de voz)', 'Sin seguimiento real de pacientes ni continuidad entre sesiones', 'Sin métricas de crecimiento ni registro de objetivos', 'Sin organización profesional que respalde tu formación', 'Sin claridad sobre tu propio avance y finanzas'];
  return <Section className="max-w-4xl" data-id="element-335">
      <div className="text-center mb-12" data-id="element-336">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-violetDark" data-id="element-337">
          ¿Cuántos pacientes más vas a gestionar de memoria?
        </h2>
        <div className="text-brand-text/80 mb-4 text-sm md:text-base max-w-2xl mx-auto space-y-4" data-id="element-338">
          <p data-id="element-339">Sos terapeuta.</p>
          <p data-id="element-340">
            Te formaste con dedicación. Hiciste cursos. Compraste libros.
            Invertiste años — y energía real — en aprender. Pero nadie te enseñó
            a organizar una consulta profesional.
          </p>
          <p data-id="element-341">
            Y hoy, cuando cerrás la sesión con un paciente, la realidad es esta:
            No recordás con exactitud qué trabajaste la semana pasada. Las
            sesiones dependen de tu memoria — y tu memoria tiene límites.
          </p>
          <p data-id="element-342">
            No estás midiendo avances. No estás registrando objetivos. No sabés
            si tu consulta está creciendo — o solo sobreviviendo. Terminás cada
            día apagando incendios.
          </p>
        </div>

        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-343">
          Y lo más difícil de admitir: no es falta de conocimiento. Es falta de
          sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-burgundy/20" data-id="element-344">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-violetDark text-base md:text-lg" data-id="element-345">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-346" /> Eso no es
          una consulta terapéutica. Es un sistema en permanente caos:
        </h3>
        <ul className="space-y-4" data-id="element-347">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-348">
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-349" />
              <span className="text-brand-text/80 text-sm md:text-base" data-id="element-350">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-351">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-352">
          ¿Y si esta fuera la última semana que trabajás así?
        </h3>
        <p className="text-brand-text/80 mt-4 max-w-xl mx-auto" data-id="element-353">
          No necesitás aprender más. No necesitás otro certificado. Necesitás
          que todo lo que ya sabés funcione con estructura.
        </p>
      </div>
    </Section>;
};